module.exports = __webpack_public_path__ + "static/media/QuickJobs.5bdbc8c2.png";